import React from "react";
import { FaCog, FaEye, FaUserCog } from "react-icons/fa";

const SettingTypeSelector = ({
  activeType,
  setActiveType,
  allIndexes = [],
  activePotIndex,
  setActivePotIndex,
  changedPotSettings = {},
}) => {
  const types = [
    { id: "GS", label: "Genel Ayarlar", shortLabel: "Genel", icon: FaCog },
    { id: "CS", label: "Göz Ayarları", shortLabel: "Göz", icon: FaEye },
    { id: "PS", label: "Profil Ayarları", shortLabel: "Profil", icon: FaUserCog },
  ];

  const showPotSelector = activeType === "CS" && allIndexes.length > 0;

  return (
    <div className="sticky top-0 z-10 bg-white border-b border-gray-200 pb-2 sm:pb-3 px-3 sm:px-2 pt-5 sm:pt-6">
      {/* Ayar Tipi Seçici — sekme stili, drawer ile uyumlu */}
      <div className="flex border-b border-gray-200 -mb-px">
        {types.map((type) => {
          const Icon = type.icon;
          const isActive = activeType === type.id;

          return (
            <button
              key={type.id}
              onClick={() => setActiveType(type.id)}
              className={`
                flex-1 flex items-center justify-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-2.5 sm:py-3
                text-xs sm:text-sm font-medium whitespace-nowrap transition-colors
                border-b-2 -mb-px
                ${isActive
                  ? "border-slate-600 text-slate-800 bg-white"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              <Icon className={`w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0 ${isActive ? "text-slate-600" : "text-gray-400"}`} />
              <span className="hidden sm:inline">{type.label}</span>
              <span className="sm:hidden">{type.shortLabel || type.label.split(" ")[0]}</span>
            </button>
          );
        })}
      </div>

      {/* Göz Seçici - sadece Göz Ayarları seçiliyken */}
      {showPotSelector && (
        <div className="flex items-center gap-1.5 mt-3 flex-wrap">
          {allIndexes.map((badgeIndex) => {
            const isActive = activePotIndex === badgeIndex;
            const hasPotChanges = Object.keys(changedPotSettings).some(
              (key) => key.endsWith(`_${badgeIndex}`)
            );
            return (
              <button
                key={badgeIndex}
                onClick={() => setActivePotIndex(badgeIndex)}
                className={`
                  relative flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-xs sm:text-sm font-medium transition-colors border
                  ${isActive
                    ? "border-slate-600 text-slate-800 bg-slate-50"
                    : "border-gray-200 text-gray-500 hover:border-gray-300 hover:text-gray-700 bg-white"
                  }
                `}
              >
                <FaEye className={`h-3 w-3 shrink-0 ${isActive ? "text-slate-600" : "text-gray-400"}`} />
                <span>{badgeIndex}. Göz</span>
                {hasPotChanges && (
                  <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-amber-400" />
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SettingTypeSelector;
